// OpenAI API call for TheoryCoach - shared to avoid circular deps with theoryCoach.ai.followUp

import { logger } from '../utils/logger';
import { SYSTEM_PROMPT } from './theoryCoach.prompts';

/**
 * Call OpenAI GPT-4o-mini for better quality responses
 */
export const callOpenAI = async (
  openai: any,
  prompt: string,
  _language: string
): Promise<string> => {
  if (!openai) {
    throw new Error('OpenAI not configured');
  }

  try {
    const response = await openai.chat.completions.create({
      model: 'gpt-4o-mini', // Cost-effective, high quality ($0.00015/1K tokens)
      messages: [
        { role: 'system', content: SYSTEM_PROMPT },
        { role: 'user', content: prompt }
      ],
      max_tokens: 300, // Allow full coach replies (2-4 sentences)
      temperature: 0.7, // Balanced creativity
      top_p: 0.9,
    });

    const content = response.choices[0]?.message?.content;
    if (content) {
      return content.trim();
    }
  } catch (error: any) {
    logger.error('OpenAI API error:', error);
    throw error;
  }

  throw new Error('No response from OpenAI');
};
